export const navLinks = [
  { name: 'Início', href: '#' },
  { name: 'Serviços', href: '#services' },
  { name: 'Sobre', href: '#about' },
  { name: 'Contato', href: '#contact' },
];

export const services = [
  {
    id: 'tax-advisory',
    title: 'Consultoria Tributária',
    icon: 'LineChart',
    description: 'Planejamento e otimização tributária para empresas de todos os portes.',
  },
  {
    id: 'legal-tax',
    title: 'Serviços Jurídicos Tributários',
    icon: 'Scale',
    description: 'Orientação especializada em regulamentações tributárias complexas e requisitos de conformidade.',
  },
  {
    id: 'consulting',
    title: 'Consultoria Empresarial',
    icon: 'Presentation',
    description: 'Assessoria profissional para melhorar o desempenho financeiro e a eficiência operacional.',
  },
  {
    id: 'accounting',
    title: 'Contabilidade',
    icon: 'Calculator',
    description: 'Serviços contábeis abrangentes adaptados às necessidades do seu negócio.',
  },
  {
    id: 'bidding',
    title: 'Auxílio em Licitações',
    icon: 'FileCheck',
    description: 'Suporte especializado em processos de licitação governamental e do setor privado.',
  },
  {
    id: 'personalized',
    title: 'Suporte Personalizado',
    icon: 'Users',
    description: 'Atendimento dedicado com soluções personalizadas para seus desafios empresariais.',
  },
];

export const benefits = [
  {
    id: 'tax-recovery',
    title: 'Recuperação de Créditos',
    description: 'Recupere impostos pagos em excesso e libere recursos que pertencem à sua empresa.',
  },
  {
    id: 'tax-planning',
    title: 'Planejamento Tributário',
    description: 'Minimize obrigações tributárias futuras através de planejamento legal e estratégico.',
  },
  {
    id: 'compliance',
    title: 'Conformidade Regulatória',
    description: 'Mantenha-se em conformidade com as constantes mudanças nas regulamentações tributárias.',
  },
  {
    id: 'cashflow',
    title: 'Fluxo de Caixa Otimizado',
    description: 'Otimize sua posição tributária para melhorar o fluxo de caixa e competitividade.',
  },
];